export const AREAS_OF_INTEREST = [
    "Industrial Automation",
    "Industry 4.0",
    "IoT Systems",
    "Software Development",
    "PLC/SCADA",
    "Smart Manufacturing",
    "Electrical Engineering"
];

export const EXPERIENCE_LEVELS = [
    "0-1 Years",
    "1-3 Years",
    "3+ Years"
];

export const JOB_TYPES = [
    "Full-Time",
    "Internship",
    "Contract"
];

export const JOB_OPENINGS = [
    {
        id: "1",
        title: "Senior Full Stack Developer (MEAN)",
        location: "Manesar, Haryana",
        type: "Full-Time",
        experience: "3+ Years",
        levelCategory: "experienced",
        category: "Software Development",
        skills: ["MongoDB", "Express", "Angular", "Node.js", "TypeScript"],
        description: "We are looking for an experienced Senior Full Stack Developer to lead the development of our next-generation manufacturing execution systems. You will be responsible for architecting, building, and deploying scalable web applications that interface with industrial IoT hardware.",
        responsibilities: [
            "Design and implement scalable full-stack web applications using the MEAN stack.",
            "Collaborate with IoT and embedded engineers to integrate real-time machine data.",
            "Lead a team of junior developers, providing mentorship and code reviews.",
            "Optimize application performance for real-time data visualization."
        ],
        requirements: [
            "Bachelor's degree in Computer Science or related field.",
            "3+ years of hands-on experience with Angular, Node.js, and MongoDB.",
            "Strong understanding of RESTful APIs and WebSocket protocols.",
            "Experience with cloud platforms (AWS/Azure) is a plus."
        ]
    },
    {
        id: "2",
        title: "IoT Embedded Engineer",
        location: "Manesar, Haryana",
        type: "Full-Time",
        experience: "1-3 Years",
        levelCategory: "experienced",
        category: "IoT Systems",
        skills: ["C/C++", "Microcontrollers", "MQTT", "PCB Design"],
        description: "Join our core hardware team to design and develop smart sensors and IoT gateways. You will work on creating intelligent devices that drive our Industry 4.0 solutions, ensuring seamless connectivity and data transmission from factory floors to the cloud.",
        responsibilities: [
            "Develop firmware for microcontrollers (ESP32, STM32, ARM Cortex).",
            "Implement IoT communication protocols (MQTT, CoAP, HTTP).",
            "Assist in hardware architecture and PCB design.",
            "Test and debug embedded systems in industrial environments."
        ],
        requirements: [
            "Degree in Electronics & Communication or Embedded Systems.",
            "1-3 years of experience in embedded C/C++ programming.",
            "Familiarity with industrial sensors and communication interfaces (RS485, Modbus).",
            "Knowledge of RTOS is highly desirable."
        ]
    },
    {
        id: "3",
        title: "Technical Sales Executive",
        location: "Manesar, Haryana",
        type: "Full-Time",
        experience: "1-3 Years",
        levelCategory: "experienced",
        category: "Industrial Automation",
        skills: ["B2B Sales", "Industrial Automation", "CRM", "Communication"],
        description: "We are seeking a dynamic Technical Sales Executive to drive the growth of our industrial automation and software solutions. You will be responsible for identifying new business opportunities, understanding client needs, and proposing technical solutions.",
        responsibilities: [
            "Generate leads and close sales in the manufacturing sector.",
            "Conduct product demonstrations and technical presentations for clients.",
            "Collaborate with the engineering team to draft custom proposals.",
            "Maintain strong relationships with existing and prospective clients."
        ],
        requirements: [
            "Degree in Engineering (Mechanical/Electrical) with an MBA preferred.",
            "Proven track record in B2B technical sales, ideally in automation.",
            "Excellent communication, negotiation, and presentation skills.",
            "Willingness to travel locally within the NCR region."
        ]
    },
    {
        id: "4",
        title: "PLC / SCADA Automation Engineer",
        location: "Manesar, Haryana",
        type: "Full-Time",
        experience: "3+ Years",
        levelCategory: "experienced",
        category: "PLC/SCADA",
        skills: ["Siemens", "Allen Bradley", "SCADA", "HMI", "Automation"],
        description: "Pitech Automation is looking for a skilled PLC/SCADA Automation Engineer to design, program, and commission control systems for custom manufacturing lines and Special Purpose Machines (SPMs).",
        responsibilities: [
            "Develop logic and program PLCs (Siemens, Allen Bradley, Mitsubishi).",
            "Design and configure HMI and SCADA screens for operator control.",
            "Conduct testing, commissioning, and troubleshooting at client sites.",
            "Prepare technical documentation and operating manuals."
        ],
        requirements: [
            "B.Tech in Electrical/Electronics Engineering.",
            "3+ years of experience in PLC programming and industrial automation.",
            "Hands-on experience with servo motors, VFDs, and industrial networking.",
            "Strong analytical and problem-solving skills."
        ]
    },
    {
        id: "5",
        title: "Smart Manufacturing Intern",
        location: "Manesar, Haryana",
        type: "Internship",
        experience: "0-1 Years",
        levelCategory: "entry",
        category: "Smart Manufacturing",
        skills: ["Python", "Data Analysis", "Manufacturing Processes", "IoT Basics"],
        description: "Kickstart your career with our Smart Manufacturing Internship! You will work closely with our Industry 4.0 consultants to analyze factory data, build basic predictive models, and learn how digital transformation is reshaping manufacturing.",
        responsibilities: [
            "Assist in collecting and analyzing machine data from client sites.",
            "Develop simple scripts in Python for data processing.",
            "Shadow senior engineers during system deployments.",
            "Prepare reports and documentation for ongoing projects."
        ],
        requirements: [
            "Currently pursuing or recently completed a degree in Engineering or Data Science.",
            "Basic understanding of manufacturing processes and Industry 4.0 concepts.",
            "Familiarity with Python or basic programming.",
            "Eagerness to learn and adapt in a fast-paced environment."
        ]
    }
];
